module.exports = __webpack_public_path__ + "img/sg.aaf8554f.png";